import { render, staticRenderFns } from "./error_500.vue?vue&type=template&id=1d5bb6fa"
import script from "./error_500.vue?vue&type=script&lang=js"
export * from "./error_500.vue?vue&type=script&lang=js"
import style0 from "./error_500.vue?vue&type=style&index=0&id=1d5bb6fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports